module.exports = {"230402001":"北山街道","230402002":"红军街道","230402003":"光明街道","230402004":"胜利街道","230402005":"南翼街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230402.json
// module id = 804
// module chunks = 0